<div class="background"></div>

<div class="plan">
  <img class="plan_image" src="assets/img/broken.svg" />
  <div class="plan_container_text">
    <h4 class="plan_text">
      {{ "sorry_the_plan_for_this_card_has_expired" | translate }}
    </h4>
    <button mat-flat-button color="primary" class="mt-3" *ngIf="update">
      {{ "upgrade_now" | translate }}
      <i class="fas fa-money-bill-wave ms-3"></i>
    </button>

    <button
      class="mat-danger ms-0 ms-md-3 mt-3 mt-md-0"
      mat-flat-button
      type="button"
      *ngIf="update"
      (click)="logout()"
    >
      <i class="fas fa-sign-out-alt me-3"></i> {{ "log_out" | translate }}
    </button>
  </div>
</div>
